import React from 'react';
import "./index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import FormContainer from './components/FormContainer';
import WelcomePage from "./components/WelcomePage";
import Page404 from "./components/Page404";
import Accomplishments from "./components/Accomplishments";

function App() {
  return (
    <div className="">
      <BrowserRouter>
          <Routes>
              <Route path={"/"} element={<WelcomePage />}/>
              <Route path={"/form"} element={<FormContainer/>}/>
              <Route path={"*"} element={<Page404/>}/>
              {/*<Route path={"/accomplishments"} element={<Accomplishments />} />*/}
          </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
